import { Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';
import { WebsiteImage } from 'components/TitleDescription';
import PropTypes from 'prop-types';

const WebsiteTrustbar = ({ heading, backgroundColor, companies }) => {
  return (
    <SectionLayout backgroundColor={backgroundColor}>
      <Row>
        <Heading fontSize="normal" textAlign="center">
          {heading}
        </Heading>
      </Row>
      <Companies>
        {companies?.map((logo, index) => {
          return (
            <LogoContainer key={index}>
              <WebsiteImage src={logo?.image} alt={logo?.alt} />
            </LogoContainer>
          );
        })}
      </Companies>
    </SectionLayout>
  );
};

export default WebsiteTrustbar;

WebsiteTrustbar.propTypes = {
  heading: PropTypes.string,
  backgroundColor: PropTypes.string,
  companies: PropTypes.objectOf(PropTypes.object),
};

WebsiteTrustbar.defaultProps = {
  heading: 'Trusted by more than 100,000+ contractors.',
  backgroundColor: 'White',
  companies: null,
};

const Heading = styled.h2`
  font-weight: 900;
  line-height: 110%;
  letter-spacing: -0.04em;
  width: 100%;
  text-align: ${props => props.textAlign};
`;

const Companies = styled.div`
  justify-content: space-around;
  align-items: center;
  display: flex;
  margin-top: 64px;
  padding: 0 28px;

  @media (max-width: 768px) {
    margin-top: 15px;
  }

  @media (max-width: 576px) {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }
`;

const LogoContainer = styled.div`
  width: 135px;
  @media (max-width: 1200px) {
    width: 125px;
  }
  @media (max-width: 768px) {
    width: 85px
  }
  @media (max-width: 576px) {
    width: 125px
    margin: 48px 15px 0;
  }
`;
